/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GeoTestPatchImplementationDTO } from './geoTestPatchImplementationDTO';
import { GeoTestPatchConversionTypesDTO } from './geoTestPatchConversionTypesDTO';
import { GeoTestPatchScheduleDTO } from './geoTestPatchScheduleDTO';
import { GeoTestPatchMediaDTO } from './geoTestPatchMediaDTO';
import { GeoTestPatchIdentityDTO } from './geoTestPatchIdentityDTO';
import { GeoTestPatchRegionsDTO } from './geoTestPatchRegionsDTO';


export interface GeoTestPatchRequestDTO { 
    /**
     * Measured client identifier. Use the client ID returned by the authenticated context.
     */
    clientId: number;
    /**
     * Brand identifier within the client. Use this together with clientId when a request targets a specific brand.
     */
    brandId: number;
    identity?: GeoTestPatchIdentityDTO;
    schedule?: GeoTestPatchScheduleDTO;
    regions?: GeoTestPatchRegionsDTO;
    media?: GeoTestPatchMediaDTO;
    conversionTypes?: GeoTestPatchConversionTypesDTO;
    implementation?: GeoTestPatchImplementationDTO;
    /**
     * Guarded lifecycle transition (e.g. DRAFT→ACTIVE to schedule, ACTIVE→DRAFT to revert). Validated with lifecycle and schedule-eligibility rules; schedule eligibility uses the request\'s schedule/implementation when present.
     */
    status?: GeoTestPatchRequestDTO.StatusEnum;
}
export namespace GeoTestPatchRequestDTO {
    export type StatusEnum = 'DRAFT' | 'ACTIVE' | 'INACTIVE';
    export const StatusEnum = {
        Draft: 'DRAFT' as StatusEnum,
        Active: 'ACTIVE' as StatusEnum,
        Inactive: 'INACTIVE' as StatusEnum
    };
}


